import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import missionsSlice from './slices/missionsSlice';
import usersSlice from './slices/usersSlice';
import messagesSlice from './slices/messagesSlice';
import professionalsSlice from './slices/professionalsSlice';
import organisationsSlice from './slices/organisationsSlice';
import helpSlice from './slices/helpSlice';
import professionalDashboardSlice from './slices/professionalDashboardSlice';
import userProfileSlice from './slices/userProfileSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    missions: missionsSlice,
    users: usersSlice,
    messages: messagesSlice,
    professionals: professionalsSlice,
    organisations: organisationsSlice,
    help: helpSlice,
    professionalDashboard: professionalDashboardSlice,
    userProfile: userProfileSlice,
  },
});

export default store;